import { faSquareArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useCallback, type FC } from 'react'

import { FlowIcon } from 'components/FlowIcon'
import { useFeatureFlag } from 'hooks/useFeatureFlag'
import { useTriggerEvent } from 'hooks/useTriggerEvent'
import { getConfiguration } from 'services/config'
import { useTranslation } from 'services/i18n'
import { useClosePanel } from 'stores/usePanelsStateStore'
import { useIsXlOrAbove } from 'stores/useScreenSizeStore'

import { ConversationsHistoryLink } from './ConversationsHistoryLink'

export const FlowAccessLinkButton: FC = () => {
  const { t } = useTranslation()

  const hasFlowAccessFeatureFlag = useFeatureFlag('workspace_product')

  const { flowUrl } = getConfiguration()

  const triggerEvent = useTriggerEvent()

  const isXlOrAbove = useIsXlOrAbove()

  const closePanel = useClosePanel()

  const handleClick = useCallback(() => {
    triggerEvent({
      name: 'kai_workspace_entry_clicked',
      properties: {
        source: 'side_panel',
        has_access: hasFlowAccessFeatureFlag,
      },
    })

    if (!isXlOrAbove) closePanel('conversations_menu')
  }, [closePanel, isXlOrAbove, triggerEvent, hasFlowAccessFeatureFlag])

  if (!hasFlowAccessFeatureFlag) return null

  return (
    <ConversationsHistoryLink
      decorator={(
        <FontAwesomeIcon icon={faSquareArrowUpRight} className="kui-btn-decorator" />
      )}
      url={flowUrl}
      icon={(
        <span>
          <FlowIcon className="block w-5" />
        </span>
      )}
      tooltipContent={t('conversation_history.flow_access_link')}
      onClick={handleClick}
      title={t('conversation_history.flow_access_link')}
      titleShort={t('conversation_history.flow_access_link_short')}
      isExternal
    />
  )
}
